import React from 'react';
import { FlexColumnBox } from 'styles/global';
import { Typography, Button, useTheme } from '@mui/material';

export default function SomethingWentWrong() {
  const theme = useTheme();
  return (
    <FlexColumnBox gap={2} minHeight="100vh">
      <Typography
        variant="h4"
        fontWeight="700"
        color={theme.palette.error.main}
      >
        Oops! Something Went Wrong
      </Typography>
      <Typography fontWeight="500" color={theme.palette.grey[600]}>
        We apologize for the inconvenience. Please try again later.
      </Typography>
      <Button
        href="/dashboard"
        component="a"
        size="large"
        variant="contained"
        sx={{
          width: 130,
          height: 35,
          fontWeight: '500',
          textTransform: 'capitalize',
          bgcolor: theme.palette.error.main,
          color: theme.palette.primary.contrastText,
        }}
      >
        Back to Home
      </Button>
    </FlexColumnBox>
  );
}
